import app from 'flarum/forum/app';
import ChatDrawer from '../components/ChatDrawer';
import chatState from '../state/chat';
import { shouldUseChatDrawer } from './surface';

/**
 * Abre (ou cria) a conversa direta com essas pessoas e a mostra. Uma pessoa dá
 * uma conversa a dois; várias, um grupo. O endpoint só reusa a conversa enquanto
 * todos os participantes estão nela; depois que alguém sai, um novo início abre
 * outro canal.
 *
 * Devolve se a conversa abriu; a falha já foi mostrada num alerta.
 */
export async function startDirect(users) {
  try {
    var _payload$data, _payload$meta, _payload$meta2, _app$current$get;
    const payload = await app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/chat/direct"),
      body: {
        data: {
          attributes: {
            userIds: users.map(user => Number(user.id()))
          }
        }
      }
    });
    const channelId = Number(payload == null || (_payload$data = payload.data) == null ? void 0 : _payload$data.id);
    if (!channelId) return false;

    // O endpoint serializa o canal encontrado ou criado, então a conversa chega com o
    // POST (ver StartDirectController::serialize).
    let channel = null;
    if ((_payload$meta = payload.meta) != null && _payload$meta.serialized) {
      try {
        channel = app.store.pushPayload(payload);
      } catch (_unused) {
        // Cai no fetch abaixo.
      }
    }
    if (!channel) {
      try {
        channel = await app.store.find('chat-channels', String(channelId));
      } catch (_unused2) {
        // O canal existe; um fetch falho só adia a atualização da lista.
      }
    }
    if (channel) chatState.rememberChannel(channel);

    // Conversa recém-criada não tem histórico nem fixada; semear os dois evita dois
    // requests que voltariam vazios.
    if ((_payload$meta2 = payload.meta) != null && _payload$meta2.created) {
      chatState.seedEmptyChannel(channelId);
    }
    chatState.setActiveChannel(channelId);

    // Na página cheia do chat (o botão da seção de mensagens diretas), a conversa
    // abre ali mesmo; a gaveta só serve a quem chega de fora, como o perfil.
    const onChatPage = String((_app$current$get = app.current.get('routeName')) != null ? _app$current$get : '').startsWith('chat.');
    if (!onChatPage && shouldUseChatDrawer()) {
      // Sem await: a gaveta pinta no primeiro frame e a lista de canais não é o que o
      // leitor veio ver.
      ChatDrawer.open().catch(() => {});
    } else {
      m.route.set(app.route('chat.channel', {
        id: channelId
      }));
    }
    return true;
  } catch (e) {
    var _e$response$errors$0$, _e$response;
    app.alerts.show({
      type: 'error'
    }, (_e$response$errors$0$ = e == null || (_e$response = e.response) == null || (_e$response = _e$response.errors) == null || (_e$response = _e$response[0]) == null ? void 0 : _e$response.detail) != null ? _e$response$errors$0$ : app.translator.trans('ramon-chat.forum.user_controls.start_chat_failed'));
    return false;
  }
}